function calculateInstallment() {
  // Select the element with data attribute 'data-subtotal'
  const cartSubtotalDiv = document.querySelector(".cart-total-value");
  // Check if the element exists
  if (cartSubtotalDiv) {
    const cartTotalText = cartSubtotalDiv.textContent;
    if (cartTotalText) {
      // Clean the cart total text
      const cleanedCartTotalText = cartTotalText
        .replace(/[^0-9.]/g, "")
        .replace(/^\.+/, "");
      const cartPageTotal = parseFloat(cleanedCartTotalText);
      // Calculate the final cart price
      const finalCartPrice = Math.floor(cartPageTotal / 3);
      const currency = sessionStorage.getItem("currency");
      // Select the element to display the installment price
      const priceDiv = document.querySelector(".alif-price-divide");
      if (priceDiv) {
        priceDiv.textContent = currency + finalCartPrice.toLocaleString();
      }
    }
  }
  // Call the function again after 1 second
  setTimeout(calculateInstallment, 1000);
}
// Initial call to the function
calculateInstallment();
